export const createTokenExpirationDate = new Date().getTime() + 10 * 1000
